export default __webpack_public_path__ + "static/media/heartEmpty.1139533d.svg";